import { Table } from "@/features/Table";
import { type AhoyEvent, ahoy_events_columns } from "./columns";
import { type FilterAhoyEventsSchema, FilterAhoyEvents } from "./filter";

const client = "admin-quantilia";
const table_name = "ahoy_events";

export const AhoyEventsTable = () => {
  return (
    <Table<AhoyEvent, FilterAhoyEventsSchema>
      label="Events" // don't change this label
      client={client}
      table_name={table_name}
      columns={ahoy_events_columns}
      filter={<FilterAhoyEvents />}
      disable_translations_request={true}
      actions={[]}
    />
  );
};
